import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../shared/common.service'; 
import { StorageService } from '../../shared/storage.service';
import { Router } from '@angular/router';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms'; // Import FormBuilder, FormGroup, Validators
import { FooterService } from '../../components/footer/footer.service';
const countryData = require('../country-code.json');

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

  contactUsForm: FormGroup; 
  contactformSubmitted = false;
  errorMessage = ''; 
  userId: any;
  countryData = countryData;

  constructor(
    private fb: FormBuilder, // Inject FormBuilder
    private router: Router,
    public commonService: CommonService,
    public userLayoutService: UserLayoutService,
    public storageService: StorageService,
    private footerService: FooterService
  ) { }

  ngOnInit(): void {
    this.footerService.hideFooter();
    this.defaultContactDetailsForm();
  }

  defaultContactDetailsForm() {
    this.contactUsForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, this.customEmailValidator()]],
      countryCode: ['+1', Validators.required],
      contactNo: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      subject: ['', Validators.required],
      message: ['', Validators.required]
    });
    this.contactformSubmitted = false
  }

  customEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const isValidEmail = emailPattern.test(control.value);
      return isValidEmail ? null : { 'invalidEmail': true };
    };
  }

  // Getter for easy access to form fields
  get f() { return this.contactUsForm.controls; }

  onSubmit() {
    this.contactformSubmitted = true;
    this.userId = localStorage.getItem("_id");

    // Stop if the form is invalid
    if (this.contactUsForm.invalid) {
      return;
    }

    // Get UserId from storage or auth service

    const contactUsData = {
      ...this.contactUsForm.value
    }

    // Call the service to submit form data
    this.userLayoutService.AddContactUs(contactUsData).subscribe(
      (response: any) => {
        if (response.code === 1) {
          // this.commonService.notifier.notify('success', response.message);
          this.storageService.setValue('userData', JSON.stringify(response.data)); 
          this.commonService.notifier.notify('success', response.message);
          this.defaultContactDetailsForm();
          this.router.navigate(['home']);
        } else {
          this.commonService.notifier.notify('error', response.message);
        }
      },
      (error) => {
        console.error('API Error:', error); // Log error to the console
        this.errorMessage = 'Something went wrong. Please try again.';
        this.commonService.notifier.notify('error', this.errorMessage);
      }
    );
    
  }

  trimWhitespace(event: any): void {
    const input = event.target;
    input.value = input.value.trim();
  }

  mobilenumberInput(event: any, formName: string, controlName: string): void {
    const input = event.target;

    // Allow only numeric values (0-9)
    input.value = input.value.replace(/[^0-9]/g, '');

    // Update the form control value
    this[formName].patchValue({
        [controlName]: input.value || null,
    });
}
}
